import { Link } from 'wouter';
import triangleLogo from '@assets/black_1787143298638.svg';

export function Footer() {
  const homeHref = import.meta.env.BASE_URL;
  return (
    <footer className="border-t border-border bg-white pt-24 pb-12">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-2">
            <Link href="/" className="flex items-center gap-3 mb-6" aria-label="Plasmics home">
              <img
                src={triangleLogo}
                alt=""
                aria-hidden="true"
                className="w-8 h-auto shrink-0"
              />
              <span className="font-sans font-bold tracking-[0.15em] text-sm mt-0.5 text-foreground">
                PLASMICS
              </span>
            </Link>
            <p className="text-muted-foreground max-w-sm text-balance leading-relaxed">
              Plasmics develops end-to-end manufacturing systems for decentralized production. A complete stack of hardware, sensing, and intelligent software.
            </p>
          </div>
          
          <div>
            <h4 className="font-mono text-xs tracking-widest text-foreground font-bold uppercase mb-6">Company</h4>
            <ul className="flex flex-col gap-4 font-light">
              <li><Link href="/" className="text-muted-foreground hover:text-primary transition-colors">Home</Link></li>
              <li><Link href="/team" className="text-muted-foreground hover:text-primary transition-colors">Team & Careers</Link></li>
              <li><a href={`${homeHref}#technology`} className="text-muted-foreground hover:text-primary transition-colors">Technology</a></li>
              <li><a href={`${homeHref}#applications`} className="text-muted-foreground hover:text-primary transition-colors">Applications</a></li>
              <li><a href={`${homeHref}#invest`} className="text-muted-foreground hover:text-primary transition-colors">Investor Relations</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-mono text-xs tracking-widest text-foreground font-bold uppercase mb-6">Legal</h4>
            <ul className="flex flex-col gap-4 font-light">
              <li><Link href="/privacy" className="text-muted-foreground hover:text-primary transition-colors">Privacy Policy</Link></li>
              <li><Link href="/imprint" className="text-muted-foreground hover:text-primary transition-colors">Imprint</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-sm font-light">
            &copy; {new Date().getFullYear()} Plasmics GmbH. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <div className="relative flex items-center justify-center">
              <span className="absolute w-3 h-3 rounded-full bg-secondary/30 animate-ping"></span>
              <span className="w-1.5 h-1.5 rounded-full bg-secondary z-10"></span>
            </div>
            <span className="text-xs font-mono text-muted-foreground uppercase tracking-widest">Vienna, Austria</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
